module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojOWY2YTI4O30uYntmaWxsOm5vbmU7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTUsMTAuNzE0SDEwLjcxNFYxNUg5LjI4NlYxMC43MTRINVY5LjI4Nkg5LjI4NlY1aDEuNDI5VjkuMjg2SDE1WiIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNMCwwSDIwVjIwSDBaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/ic_add_24px.svg
// module id = 556
// module chunks = 0